export default __webpack_public_path__ + "9d6db6ed16d7cdb600112aaa47f81692.jpg";